import Prismic from 'prismic-javascript';

let client;

const CMSUtils = {
    init() {
        const apiEndpoint = 'https://spothero.prismic.io/api/v2';

        client = Prismic.client(apiEndpoint);
    },
    getPageData({slug, customType}) {
        // if path has multiple parts, only use last part of path
        let cleanedSlug = slug;

        if (slug.includes('/')) {
            const path = slug.split('/').filter(Boolean);

            cleanedSlug = path[path.length - 1];
        }

        return client.getByUID(customType, cleanedSlug).then(result => {
            if (!result || !result.data) {
                // eslint-disable-next-line no-throw-literal
                throw {
                    status: 404,
                    message: `Page with slug ${slug} does not exist in Prismic data`,
                };
            } else {
                return result.data;
            }
        });
    },
};

export default CMSUtils;
